export default "__VITE_ASSET__CYeGUpM9__"